import http from '@/services/http';
import apiEndpoints from '@/services/apiEndpoints';
import constRole from '@/configs/role';
const getDefaultState = () => {
  return {
    user: {},
    token: '',
    role: '',
  };
};

const state = getDefaultState();
const getters = {
  user (state) {
    return state.user;
  },
  token (state) {
    return state.token;
  },
  role (state) {
    return state.role;
  },
  isVendor (state) {
    return state.role === constRole.vendor;
  },
  isAdmin (state) {
    return state.role === constRole.admin;
  },
};
const mutations = {
  SET_USER (state, { token, user, role }) {
    state.token = token;
    state.user = user;
    state.role = role;
  },
  UNSET_USER (state) {
    state.token = '';
    state.user = {};
    state.role = '';
  },
};
const actions = {
  async loginAdmin ({ commit }, payload) {
    const resLogin = await http.post(apiEndpoints.login, payload);
    const { status, data } = resLogin;
    if (status) {
      const { token, user, status: loginStatus, role } = data.result;
      if (loginStatus === false) {
        return false;
      }
      commit('SET_USER', {
        token,
        user,
        role,
      });
      return true;
    } else {
      return false;
    }
  },
  async logoutAdmin ({ commit }, payload) {
    await http.post(apiEndpoints.logout);
    commit('UNSET_USER');
    return true;
  },
  async sendResetLinkToVendor (_, payload) {
    return await http.post(apiEndpoints.vendorSendLink, payload);
  },
  async vendorResetPassword (_, payload) {
    return await http.post(apiEndpoints.vendorResetPassword, payload);
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
